import React from 'react'

import { useQuery } from '@shared/hooks/query'

import { useAuth } from '@shared/hooks/auth'

import { useHistory } from 'react-router-dom'

import { Centered, Content } from '@shared/components/Layout'

const Modules = () => {
  const { getQueryParams } = useQuery()
  const {
    token: authorization,
    unit: unit_id,
    module: module_id
  } = getQueryParams()

  const { authByToken, module } = useAuth()

  const history = useHistory()

  React.useEffect(
    function authenticateUserWithAuthorizationToken () {
      authByToken({
        authorization,
        unit_id,
        module_id
      })
    },
    [authByToken, authorization, unit_id, module_id]
  )

  React.useEffect(
    function redirectToModuleOnAuth () {
      history.push(module ? module.meta.path : '/modules')
    },
    [history, module]
  )

  return (
    <Centered>
      <Content isLoading>
      </Content>
    </Centered>
  )
}

export default Modules
